import * as _ from "lodash";
import { useState } from 'react';
import { ToDoColumnWrapper } from '../styles';
import { IAdminActionCenterToDo } from '@nkr/models/index';
import { ActionItem } from '../models';
import { MainType } from './models/main-type';
import { Glyphicon, Row } from 'react-bootstrap';
import ActionCenterItem from './action-center-item-count';

interface IProps {
    data: IAdminActionCenterToDo,
    showLoading: boolean,
    hideEmptyItems: boolean,
    isAdmin: boolean,
    onItemClick: (mainType: MainType, subType: ActionItem) => void
}

const ToDoCountsOnly = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleItemClick = (subType: ActionItem) => {
        props.onItemClick(MainType.ToDo, subType);
    };

    const matchOffers = props.data != null ? props.data.matchOffers : 0;
    const donorClearance = props.data != null ? props.data.donorClearance : 0;
    const preSelectsOutstanding = props.data != null ? props.data.preselectsOutstanding : 0;
    const requestsForDonorReview = props.data != null ? props.data.requestsForDonorReview : 0;
    const xmResultsDueToday = props.data != null ? props.data.xmResultsDueToday : 0;
    const confirmReimbursementDonations = props.data != null ? props.data.confirmReimbursementDonations : 0;
    const missingAdpVoucherHolders = props.data ? props.data.missingVoucherHolders : 0;
    const customLogistics = props.data ? props.data.customLogistics : 0;
    const pendingRccaps = props.data ? props.data.pendingRccaps : 0;
    const inactiveDonorsInRange = props.data ? props.data.inactiveDonorsInRange : 0;
    const donorEvalOutOfDate = props.data ? props.data.donorEvalOutOfDate : 0;
    const hasAbWaitListPatients = props.data != null ? props.data.abWaitListPatients : 0;
    const dashToDo = props.data != null ? props.data.dashToDo : 0;
    const flaggedForVoucherDonation = props.data != null ? props.data.flaggedForVoucherDonation : 0;
    const outstandingInternalDirectSwaps = props.data != null ? props.data.outstandingInternalDirectSwaps : 0;
    const missingVoucherConsents = props.data != null ? props.data.missingVoucherConsents : 0;
    const patientIntakeReferrals = props.data != null ? props.data.patientIntakeReferrals : 0;
    const atRiskMortalityRecipients = props.data != null ? props.data.mortalityRecipients : 0

    const items = [
        { name: 'Match Offers', count: matchOffers, actionItem: ActionItem.MatchOffers, show: true },
        { name: 'Donor Clearance', count: donorClearance, actionItem: ActionItem.DonorClearance, show: true },
        { name: 'Pre-Selects', count: preSelectsOutstanding, actionItem: ActionItem.Preselects, show: true },
        { name: 'Requests for Donor Review', count: requestsForDonorReview, actionItem: ActionItem.RequestForDonorReview, show: true },
        { name: 'XM Results', count: xmResultsDueToday, actionItem: ActionItem.XMResults, show: true },
        { name: 'Confirm Donor Reimbursement Eligibility', count: confirmReimbursementDonations, actionItem: ActionItem.ConfirmReimbursementDonations, show: true },
        { name: 'Missing Voucher Holders', count: missingAdpVoucherHolders, actionItem: ActionItem.MissingVoucherHolders, show: true },
        { name: 'Custom Logistics', count: customLogistics, actionItem: ActionItem.CustomLogistics, show: true },
        { name: 'RCCAPs', count: pendingRccaps, actionItem: ActionItem.Rccap, show: true },
        { name: 'Donation Date Range Conflict', count: inactiveDonorsInRange, actionItem: ActionItem.DonationDateRangeConflict, show: true },
        { name: 'Donor Evals', count: donorEvalOutOfDate, actionItem: ActionItem.DonorEval, show: true },
        { name: 'AB Waitlist Patients', count: hasAbWaitListPatients, actionItem: ActionItem.HasAbWaitListPatients, show: true },
        { name: 'DASH To-Do', count: dashToDo, actionItem: ActionItem.DashContactDue, show: true },
        { name: 'Flagged for Voucher Donation', count: flaggedForVoucherDonation, actionItem: ActionItem.FlaggedForVoucherDonation, show: true },
        { name: 'Confirm ID Donation/Transplant Occurred', count: outstandingInternalDirectSwaps, actionItem: ActionItem.OutstandingInternalDirectSwaps, show: true },
        { name: 'Missing Voucher Holder Consents', count: missingVoucherConsents, actionItem: ActionItem.MissingVoucherConsents, show: true },
        { name: 'Pending Patient Intake Referrals', count: patientIntakeReferrals, actionItem: ActionItem.PendingPatientIntakeReferrals, show: true },
        { name: 'At Risk Mortality Recipients', count: atRiskMortalityRecipients, actionItem: ActionItem.AtRiskMortalityRecipients, show: true},
    ];

    const isEmpty = items.filter(x => x.count == 0).length == items.length;
    const itemCount = items.filter(x => x.count > 0).length;
    const itemList = _.sortBy(items, item => item.name);

    let title = props.isAdmin ? 'TO-DO - All Centers' : 'TO-DO';

    return (
        <div className='section-urgent' style={{ marginBottom: 20 }}>
            <div className='title-container'>
                <div className={props.isAdmin ? 'title admin-title' : 'title'} onClick={() => setExpanded(!expanded)}>
                    <h4>{title} <span>({itemCount})</span></h4>
                    <span style={{ paddingLeft: 5, color: 'white' }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
                <div style={{ borderBottom: '1px solid var(--red)', width: '85%' }}>&nbsp;</div>
            </div>
            {expanded ?
                <div className='content' style={{ backgroundColor: props.showLoading ? '#eee' : null, opacity: props.showLoading ? 0.5 : 1 }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Loading urgent items, one moment please...</div></div>
                    )}

                    <div className='container-fluid'>
                        <Row>
                            {itemList.map((item, index) => {
                                if (((!props.hideEmptyItems && item.count == 0) || item.count > 0) && item.show) {
                                    return (
                                        <ToDoColumnWrapper key={index} className="col-xs-12 col-lg-3">
                                            <ActionCenterItem
                                                description={item.name}
                                                count={item.count}
                                                isList={true}
                                                highlight="#c90a0a"
                                                actionItem={item.actionItem}
                                                onItemClick={handleItemClick}
                                            />
                                        </ToDoColumnWrapper>
                                    )
                                }
                            })}

                            {isEmpty && props.hideEmptyItems && (
                                <ToDoColumnWrapper className='col-xs-12 col-lg-12' style={{ fontSize: 16 }}>
                                    At this time, there are no urgent items
                                </ToDoColumnWrapper>
                            )}
                        </Row>
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    )
}

export default ToDoCountsOnly;